import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faEye,
  faPen,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";

import "./MenuEdit.css";
import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import MenuForm from "./MenuForm";
import MenuGroupForm from "./MenuGroupForm";
import MenuMediaForm from "./MenuMediaForm";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: this.props.match.params.menuID,
      data: [],
      error: null,
      form: null,
      isLoading: true,
      modalLoading: false,
      modalOpen: false,
      text: "",
      menuName: "",
      menuItemsData: [],
      mediaSelected: [],
      menuItemMediaSelected: [],
      groupSelected: [],
      groupData: [],
      menuItemSelected: [],
      sectionSelected: [],
      themes: [],
      user: this.props.auth.googleId
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
  }

  componentDidMount() {
    this.props.fetchUser();
    this.props.fetchThemes();
    this.props.fetchGroups();
    this.props.fetchMenuItems(localStorage.getItem("SubscriptionId"));
    this.props.fetchMenuItemsMedia(localStorage.getItem("SubscriptionId"));
    this.loadMenu();
    this.loadMenuItems();
    this.loadGroups();
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.loadMenu();
  };

  loadMenu() {
    this.setState({
      isLoading: true
    });

    const ApiMenusQuery =
      "/Menu(" +
      this.state.current +
      ")?$filter=SubscriptionId eq '" +
      localStorage.getItem("SubscriptionId") +
      "'&$select=Name,Oid,Id,Theme,R1C1,R1C2,R1C3,R1C4,R2C1,R2C2,R2C3,R2C4&$expand=Theme,R1C1,R1C1/GroupToShow,R1C1/MediaToShow,R1C2/MediaToShow,R1C2,R1C2/GroupToShow,R1C2/MediaToShow,R1C3,R1C3/GroupToShow,R1C3/MediaToShow,R1C4,R1C4/GroupToShow,R1C4/MediaToShow,R2C1,R2C1/GroupToShow,R2C1/MediaToShow,R2C2,R2C2/GroupToShow,R2C2/MediaToShow,R2C3,R2C3/GroupToShow,R2C3/MediaToShow,R2C4,R2C4/GroupToShow,R2C4/MediaToShow&$format=json";
    axios({
      method: "get",
      url: CONFIG.API_URL + ApiMenusQuery,
      headers: {
        "Content-Type": "application/json",
        Auth: CONFIG.API_KEY
      }
    })
      .then(result =>
        this.setState({
          data: result.data.d,
          isLoading: false
        })
      )
      .catch(error =>
        this.setState({
          error,
          isLoading: false
        })
      );
  }

  loadMenuItems() {
    this.setState({
      isLoading: true
    });

    const ApiMenuItemsQuery =
      "/MenuItems?$filter=SubscriptionId eq '" +
      localStorage.getItem("SubscriptionId") +
      "'&$select=Name,Oid,GroupToShow&$expand=GroupToShow&$format=json";
    axios({
      method: "get",
      url: CONFIG.API_URL + ApiMenuItemsQuery,
      headers: {
        "Content-Type": "application/json",
        Auth: CONFIG.API_KEY
      }
    })
      .then(result => {
        this.setState({
          menuItemsData: result.data.d,
          isLoading: false
        });
      })
      .catch(error =>
        this.setState({
          error,
          isLoading: false
        })
      );
  }

  loadGroups() {
    this.setState({
      isLoading: true
    });

    const ApiGroupQuery =
      "/Group?$filter=SubscriptionId eq '" +
      localStorage.getItem("SubscriptionId") +
      "'&$orderby=Name&$select=Name,Oid,SortOption&$expand=SortOption&$format=json";
    axios({
      method: "get",
      url: CONFIG.API_URL + ApiGroupQuery,
      headers: {
        "Content-Type": "application/json",
        Auth: CONFIG.API_KEY
      }
    })
      .then(result => {
        this.setState({
          groupData: result.data.d,
          isLoading: false
        });
        this.loadGroupsToState(result.data.d);
      })
      .catch(error =>
        this.setState({
          error,
          isLoading: false
        })
      );
  }
  loadGroupsToState = inputData => {
    let output = [];
    inputData.map((record, index) => {
      output.push({
        value: record.Oid,
        label: record.Name
      });
      return true;
    });
    this.setState({
      groupData: output
    });
  };

  render() {
    const RenderPlaceholder = () => {
      return <Spinner />;
    };

    /* const renderBackground = () => {
      if (this.state.data.Theme) {
        let classBG = "theme-" + this.state.data.Theme.Type;
        //document.body.classList.add(classBG);
      }
    }; */

    const RenderContent = props => {
      let classBG = "menu-area";
      if (this.state.data.Theme) {
        classBG = "menu-area theme-" + this.state.data.Theme.Type;
      }

      let deleteButton = "";
      if (localStorage.getItem("UserIsAdmin") === "true") {
        deleteButton = (
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleDeleteMenu}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" /> Delete
          </button>
        );
      }

      return (
        <div>
          <Link className="waves-effect waves-light btn" to="/menus">
            <FontAwesomeIcon icon={faChevronLeft} size="lg" /> Back to Menus
          </Link>
          <h1>{props.title}</h1>
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleEditMenu}
          >
            <FontAwesomeIcon icon={faPen} size="lg" /> Edit
          </button>
          &nbsp;
          {deleteButton}
          &nbsp;
          <a
            href={"https://menus.kler.io/m/" + this.state.data.Id}
            className="waves-effect waves-light btn"
            target="kler-preview"
          >
            <FontAwesomeIcon icon={faEye} size="lg" /> Preview
          </a>
          <div className={classBG}>
            {renderGroup("R1C1", this.state.data.R1C1)}
            {renderGroup("R1C2", this.state.data.R1C2)}
            {renderGroup("R1C3", this.state.data.R1C3)}
            {renderGroup("R1C4", this.state.data.R1C4)}
            {renderGroup("R2C1", this.state.data.R2C1)}
            {renderGroup("R2C2", this.state.data.R2C2)}
            {renderGroup("R2C3", this.state.data.R2C3)}
            {renderGroup("R2C4", this.state.data.R2C4)}
          </div>
        </div>
      );
    };

    const renderGroup = (section, reference) => {
      let selectGroupMedia = (
        <div className="menu-group inactive">
          <h4>
            No <br />
            Content
          </h4>
          <div>
            <button
              className="waves-effect waves-light btn"
              onMouseDown={handleEditGroup}
              data-oid=""
              data-name=""
              data-section={section}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" /> Group
            </button>
            <br />
            <button
              className="waves-effect waves-light btn"
              onMouseDown={handleEditMedia}
              data-oid=""
              data-name=""
              data-section={section}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" /> Media
            </button>
          </div>
        </div>
      );

      if (reference && (reference.GroupToShow || reference.MediaToShow)) {
        if (reference.GroupToShow && reference.GroupToShow.Name !== "None") {
          selectGroupMedia = (
            <div className="menu-group">
              <div className="preview preview-group">
                <div className="menu-group-name">
                  {reference.GroupToShow.Name}
                </div>
                <div className="menu-preview-icon">
                  <img
                    src={require("../../assets/kler-group-icon.png")}
                    alt="Media"
                  />
                </div>
              </div>
              <button
                className="waves-effect waves-light btn"
                onMouseDown={handleEditGroup}
                data-oid={reference.Oid}
                data-name={reference.GroupToShow.Name}
                data-section={section}
              >
                {reference.GroupToShow.Name}
              </button>
            </div>
          );
        }

        if (reference.MediaToShow && reference.MediaToShow.Name) {
          selectGroupMedia = (
            <div className="menu-group">
              <div className="preview">
                <img
                  src={
                    "https://klerfiles.blob.core.windows.net" +
                    reference.MediaToShow.Url
                  }
                  alt="Media"
                />
              </div>
              <button
                className="waves-effect waves-light btn"
                onMouseDown={handleEditMedia}
                data-oid={reference.Oid}
                data-name={reference.MediaToShow.Name}
                data-section={section}
              >
                {reference.MediaToShow.Name}
              </button>
            </div>
          );
        }
      }
      return selectGroupMedia;
    };

    // ***************************
    // EDIT MENU FUNCTIONALITY
    const handleEditMenu = e => {
      this.setState({
        form: "edit",
        modalOpen: true,
        menuName: this.state.data.Name
      });
    };

    // ***************************
    // DELETE MENU FUNCTIONALITY
    const handleDeleteMenu = e => {
      this.setState({ form: "delete", modalOpen: true });
    };
    const renderDeleteMenuForm = e => {
      return (
        <div className="txt-center">
          <div>Are you sure you want to delete?</div>
          <div>
            <h4>{this.state.data.Name}</h4>
          </div>
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleDeleteMenuSubmitted}
          >
            Confirm
          </button>
          &nbsp;
          <button
            className="waves-effect waves-light btn"
            onMouseDown={this.handleClose}
          >
            Cancel
          </button>
        </div>
      );
    };
    const handleDeleteMenuSubmitted = () => {
      this.setState({
        modalLoading: true
      });
      const DeleteMenuQuery = "/Menu(" + parseInt(this.state.data.Oid) + ")";
      axios({
        method: "delete",
        url: CONFIG.API_URL + DeleteMenuQuery,
        headers: {
          "Content-Type": "application/json",
          Auth: CONFIG.API_KEY
        }
      })
        .then(result => {
          this.props.history.push("/menus");
        })
        .catch(error => console.log(error));
    };

    // ***************************
    // EDIT GROUP FUNCTIONALITY
    const handleEditGroup = e => {
      // var groupSelected = this.state.groupSelected;
      let groupSelected = [];
      if (groupSelected !== null) {
        groupSelected = {
          value: e.target.dataset.oid,
          label: e.target.dataset.name
        };
      }
      this.setState({
        form: "edit-group-select",
        modalOpen: true,
        groupSelected: groupSelected,
        menuItemSelected: e.target.dataset.oid,
        sectionSelected: e.target.dataset.section
      });
    };

    // ***************************
    // EDIT MEDIA FUNCTIONALITY
    const handleEditMedia = e => {
      let mediaSelected = [];
      if (mediaSelected !== null) {
        mediaSelected = {
          value: e.target.dataset.oid,
          label: e.target.dataset.name
        };
      }
      this.setState({
        form: "edit-media-select",
        modalOpen: true,
        mediaSelected: mediaSelected,
        menuItemMediaSelected: e.target.dataset.oid,
        sectionSelected: e.target.dataset.section
      });
    };

    const renderForm = type => {
      switch (type) {
        case "edit":
          return (
            <div>
              <MenuForm
                id={this.state.data.Oid}
                data={this.state.data}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                themes={this.props.themes}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
              />
            </div>
          );
        case "delete":
          return renderDeleteMenuForm();
        case "edit-group-select":
          return (
            <div>
              <MenuGroupForm
                id={this.state.data.Oid}
                data={this.state.data}
                menuItems={this.props.menuItems}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
                section={this.state.sectionSelected}
                selected={this.state.menuItemSelected}
              />
            </div>
          );
        case "edit-media-select":
          return (
            <div>
              <MenuMediaForm
                id={this.state.data.Oid}
                data={this.state.data}
                menuItems={this.props.menuItemsMedia}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
                section={this.state.sectionSelected}
                selected={this.state.menuItemMediaSelected}
              />
            </div>
          );
        default:
          return RenderPlaceholder();
      }
    };

    return (
      <div className="component-menu pad-20">
        {this.state.isLoading ? (
          <RenderPlaceholder />
        ) : (
          <RenderContent title={this.state.data.Name} />
        )}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.data)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    themes: state.themes,
    menuItems: state.menuItems,
    menuItemsMedia: state.menuItemsMedia
  };
}

export default connect(
  mapStateToProps,
  actions
)(Component);
